import React from "react";
import Menu from "../Menu";
import Footer from "../footer";
import ReactGA from "react-ga";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";

// import { hotjar } from 'react-hotjar';

const url = "https://bus-dev.appgw.ftpra.com"


class Final extends React.Component {
    componentDidMount() {
        ReactGA.pageview(`/final-${this.props.store.userDataReducer.final_code_url}`);
        //hotjar.initialize(1592041,6);
    }

    renderRedirect = () => {
        if (this.props.store.userDataReducer.final_code_url === null) {
            return <Redirect to={{pathname: "/"}}/>;
        }
    };

    render() {
        const finalPageText = () => {
            console.log("(this.props.store.userDataReducer", this.props.store.userDataReducer);
            switch (this.props.store.userDataReducer.final_code_url) {
                case 3:
                    return (
                        <div className="infoterms">
                            <p>Увага!</p>
                            <p>
                                Ваш номер телефону вже зареєстрований. Для оформлення та оплати кредиту увійдіть в ваш особистий кабінет.
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 0:
                    return (
                        <div>
                            <div className="infoterms">
                                <p>Увага!</p>
                                <p>
                                    "Наступний крок - дзвінок від нашого спеціаліста і це дуже важливо для отримання кредиту. Ми телефонуємо в робочі дні з 8:00 до 21:00, а у вихідні - з с 10:00 до 19:00."
                                </p>
                            </div>
                        </div>
                    );
                case 1:
                    return (
                        <div>
                            <div className="infoterms">
                                <p>Увага!</p>
                                <p>
                                    "Наступний крок - дзвінок від нашого спеціаліста і це дуже важливо для отримання кредиту. Ми телефонуємо в робочі дні з 8:00 до 21:00, а у вихідні - з с 10:00 до 19:00."
                                </p>
                            </div>
                        </div>
                    );
                case 5:
                    return (
                        <div className="infoterms">
                            <p>Увага!</p>
                            <p>
                                Ваш номер телефону вже зареєстрований. Для оформлення та оплати кредиту увійдіть в ваш особистий кабінет.
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 2:
                    return (
                        <div className="infoterms">
                            <p>Чудово!</p>
                            <p>
                                Переходьте в особистиий кабінет. Логін - Ваш номер телефону; пароль - 8 знаків з СМС-повідомлення від Shv.Groshi. 
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 6:
                    return (
                        <div className="infoterms">
                            <p>Вітаємо!</p>
                            <p>
                                Ви - наш клієнт. Отримайте кредит в особистому кабінеті. Логін - Ваш номер телефону; пароль - 8 знаків з СМС-повідомлення від Shv.Groshi. 
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 9:
                    return (
                        <div className="infoterms">
                            <p>Вітаємо!</p>
                            <p>
                                Ви - наш клієнт. Отримайте кредит в особистому кабінеті. Логін - Ваш номер телефону; пароль - 8 знаків з СМС-повідомлення від Shv.Groshi. 
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 4:
                    return (
                        <div className="infoterms">
                            <p>Чудово!</p>
                            <p>
                                Продовжыть заповнення заявки в особистому кабінеті. Логін - Ваш номер телефону; пароль - 8 знаків з СМС-повідомлення від Shv.Groshi. 
                            </p>
                            <button className="finalpagebutton">
                                <a href={`${url}/kabinet/`}>
                                    Увійти в особистий кабінет
                                </a>
                            </button>
                        </div>
                    );
                case 8:
                    return (
                        <div className="infoterms">
                            <p>
                                Нажаль, Ви поки що не можете отримати кредит. Рекомендуємо звернутися до нас повторно через 10 днів. 
                            </p>
                        </div>
                    );
                case 7:
                    return (
                        <div className="infoterms">
                            <p>Увага!</p>
                            <p>
                                Ваша заявка принята. В ближайшее время с Вами свяжется наш специалист. Звонки:
                                Пн.-Пт. 8 00- 20 00 Сб. Вс. 10 00-19 00..

                                Ваша заявка прийнята. В найближчий час з вами зв'яжеться наш спеціаліст. Дзвінки: Пн.-Пт. 8 00- 20 00 Сб. Вс. 10 00-19 00.
                            </p>
                            {/* <button className="finalpagebutton">
                <a href="https://sgroshi.com.ua/kabinet/?partner=pgf5&utm_source=pgf5&utm_medium=cpc&utm_campaign=site&utm_content=pgf5">
                  Войти в личный кабинет
                </a>
              </button> */}
                        </div>
                    );
            }
            //
            // if (this.props.store.userDataReducer.final_code_url === '5') {
            //     return (
            //         <div className="infoterms">
            //             <p>Внимание!</p>
            //             <p>Ваш телефон уже зарегистрирован. Для оформления и оплаты кредита войдите в свой личный кабинет.</p>
            //             <button className="finalpagebutton"><a href="https://sgroshi.com.ua/kabinet/?partner=pgf5&utm_source=pgf5&utm_medium=cpc&utm_campaign=site&utm_content=pgf5">Войти в личный кабинет</a></button>
            //         </div>
            //     )
            // } else if (this.props.store.userDataReducer.final_code_url === '3') {
            //     return (
            //         <div className="infoterms">
            //             <p>Внимание!</p>
            //             <p>Для оформления и оплаты кредита войдите в свой личный кабинет. </p>
            //             <button className="finalpagebutton"><a href="https://sgroshi.com.ua/kabinet/?partner=pgf3&utm_source=pgf3&utm_medium=cpc&utm_campaign=site&utm_content=pgf3">Войти в личный кабинет</a></button>
            //         </div>
            //     )
            // } else {
            //     return (
            //         <div className="infoterms">
            //             <p>Спасибо!</p>
            //             <p>Ваша заявка принята. В ближайшее время с Вами свяжется наш специалист. Звонки: Пн.-Пт. 8 00- 20 00 Сб. Вс. 10 00-19 00.</p>
            //         </div>
            //     )
            // }
        };
        return (
            <div>
                {this.renderRedirect()}
                <Menu/>
                <div className="main-block-registration">{finalPageText()}</div>
                <Footer/>
            </div>
        );
    }
}

export default connect((state) => ({store: state}))(Final);



// WEBPACK FOOTER //
// src/pages/finalpage.js